import React from "react"
import Plot from "../components/plotly"

const DeathChart = ({ cases, numTests }) => {
  return (
    <Plot
      data={[
        { ...cases, opacity: 0.4 },
        { ...numTests, yaxis: "y2" },
      ]}
      layout={{
        showlegend: true,
        legend: {
          orientation: "h",
          yanchor: "bottom",
          xanchor: "left",
          y: -0.2,
        },
        xaxis: { fixedRange: true },
        yaxis: { fixedRange: true, title: "Cases" },
        yaxis2: {
          overlaying: "y",
          fixedRange: true,
          side: "right",
          rangemode: "tozero",
          title: "Tests",
        },
      }}
      onClick={event => console.log(event)}
      onSelected={event => console.log(event)}
    />
  )
}

export default DeathChart
